export const CONFIGURATION_TYPE = [
    {
        value: 1,
        label: "JSON"
    },
    {
        value: 2,
        label: "JSON数组"
    },
    {
        value: 3,
        label: "图片类"
    },
    {
        value: 4,
        label: "文件类"
    },
    {
        value: 5,
        label: "开关类"
    },
    {
        value: 6,
        label: "文字类"
    }
];

export const findCONFIGURATIONTYPEByValue = value => {
    return CONFIGURATION_TYPE.find(item => item.value === value)||{};
};